import { IRouterOption } from 'src/router'
import { CommunityState } from './[state]'
import { ECommunityRoutes } from './routes.enum'

export const CommunityRoutes: IRouterOption[] = [
  {
    path: ECommunityRoutes.COMMUNITY_STATE,
    component: CommunityState,
    name: ECommunityRoutes.COMMUNITY_STATE,
    exact: true,
    meta: {}
  }
]
